import { searchApiClient } from '@/datasources/search.datasource';
import {
  SearchApiFacilityResult,
  SearchApiTermResponse,
} from '@/app/(main)/_components/search-modal/_services/search-api/search-api.type';

export interface FindPartnerFacilitiesByTermParams {
  term: string;
  citySlug?: string;
  page?: number;
  limit?: number;
}

export interface FindPartnerFacilitiesByTermResult {
  facilities: SearchApiFacilityResult[];
  hasMore: boolean;
}

export async function findPartnerFacilitiesByTerm({
  term,
  citySlug,
  page,
  limit,
}: FindPartnerFacilitiesByTermParams): Promise<FindPartnerFacilitiesByTermResult> {
  const response = await searchApiClient.get<SearchApiTermResponse<SearchApiFacilityResult>>(
    '/partners/facilities/find-by-term',
    {
      term,
      city: citySlug,
      page,
      limit,
    },
  );

  return {
    facilities: response.data.data ?? [],
    hasMore: response.data.hasMore ?? false,
  };
}
